package ui.hardware

import androidx.compose.runtime.*
import androidx.compose.ui.text.input.*
import common.frontend.api.*
import io.*
import kotlinx.coroutines.*
import org.jetbrains.compose.resources.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.viewmodel.*
import tk.mallumo.utils.*

@VM
class HardwareListingVM : NavigationViewModel() {

    private lateinit var scopeUi: HardwareListingScope

    var state by mutableDataState<HardwareListingScope.Wrapper>()
        private set


    val searchFiled = mutableStateOf(TextFieldValue(""))

    sealed interface Action {
        //        class New(val item: Io.ListingServer.Item) : Action
        companion object {

            @Composable
            fun rememberAction(vm: HardwareListingVM): (Action) -> Unit {
                return remember {
                    { act ->

                    }
                }
            }
        }
    }


    fun init(scopeUi: HardwareListingScope) {
        this.scopeUi = scopeUi
        if (state !is DataState.Result) {
            state = DataState.Loading()
        }

        scope.launch {
            runCatching {
                state = DataState.Result(
                    HardwareListingScope.Wrapper(
                        hardware = Repository.api.hardware.listing(),
                        canAdd = scopeUi.login.canHardwareAdd()
                    )
                )
            }.onFailure {
                it.printStackTrace()
                state = DataState.Error(getString(Res.string.err_connection_interrupted))
            }
        }
    }

    override fun onRelease() {
        state.entry?.release()
        state = DataState.Idle()
    }

}
